import { StyledCta } from 'components/marketingSite/shared/Cta.styled';
import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import { color, container, fontSize, spacing } from '../../../theme';

export const StyledBlog = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  max-width: ${container('xl')};
  margin: auto;
  text-align: center;

  ${StyledCta} {
    margin-top: ${spacing('xl5')};
  }
`;

export const StyledBlogHeader = styled.header`
  text-align: center;
  font-size: ${fontSize('lg')};
  margin-bottom: ${spacing('xl3')};

  ${Heading1} {
    margin-bottom: ${spacing('lg')};
  }
`;

export const StyledTags = styled.div`
  border-top: 1px solid ${color('midnight_200')};
  border-bottom: 1px solid ${color('midnight_200')};
  padding-top: ${spacing('md')};
  padding-bottom: ${spacing('md')};
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('xs')};
  margin-bottom: ${spacing('xl3')};
`;

export const StyledBlogCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('lg')};
  max-width: ${container('md')};
  margin: auto;
`;
